import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { DvlSettingsService } from '../services/settings.service';
import { AuthService } from '../services/auth.service';
import { DvlBirthdaysService } from '../services/birthdays.service';
import { DvlBraceletColorPipe } from '../pipes/bracelet-color.pipe';
import { Birthday } from '../models/birthday.model';

@Component({
  selector: 'dvl-kitchen',
  templateUrl: './kitchen.component.html'
})
export class DvlKitchenComponent {
  private turnSelected: string;
  private birthdayFocus: any;
  private totalOrders: number;
  private birthdays: any[];
  private bracelets: any[];
  private orders: any[];
  private foods: any[];
  private desserts: any[];
  private showAlerts: boolean;
  private pendingAlerts: any[];
  private showInfoForm: boolean;

  private timetable$: Observable<any[]>;

  constructor(
    private settingsService: DvlSettingsService,
    private birthdaysService: DvlBirthdaysService,
    private formBuilder: FormBuilder,
    private braceletPipe: DvlBraceletColorPipe,
    private router: Router,
    private authService: AuthService
  ) {
    this.birthdayFocus = new Birthday({});
    this.timetable$ = this.settingsService.timetable$;
    this.orders = [];
    this.foods = [];
    this.desserts = [];
    this.pendingAlerts = [];
    this.totalOrders = 0;

    this.settingsService.bracelets$.subscribe((bracelets) => this.bracelets = bracelets);
    this.settingsService.desserts$.subscribe((desserts) => this.desserts = desserts);
    this.settingsService.foods$.subscribe((foods) => this.foods = foods);
    this.birthdaysService.birthdays$.subscribe((birthdays) => {
      this.birthdays = birthdays.filter((birthday) => birthday.sentToKitchen);

      if (this.turnSelected) {
        this.selectHour(this.turnSelected);
      }
    });
    this.timetable$.subscribe((timetable) => this.selectHour(timetable[0].hour));

    this.authService.isLogged.subscribe((value) => {
      if (!value) {
        this.router.navigate(['/']);
      }
    });
  }

  private selectHour(hour: string): void {
    this.turnSelected = hour;

    if (this.birthdays) {
      this.birthdayFocus = this.birthdays.find((birthday) => birthday.turn === this.turnSelected) || new Birthday({});
      this.pendingAlerts = (this.birthdayFocus && this.birthdayFocus.updates) ? this.birthdayFocus.updates.filter((update) => !update.read) : [];
    }

    this.orders = this.getOrders(this.birthdayFocus.attendees || []);
    this.totalOrders = this.orders.reduce((acc, order) => acc + order.total, 0);
  }

  private getBraceletColor(turn: number): string {
    let birthday: any = this.birthdays.find((el) => el.turn === turn);
    return this.braceletPipe.transform((birthday) ? birthday.bracelet : '', this.bracelets);
  }

  private getOrders(attendees: any[]): any[] {
    return this.foods.map((food) => {
      let dif: any = this.pendingAlerts.filter((update) => !update.read && update.food === food.$key).filter((update) => update.dif !== undefined).reduce((acc, update) => acc + update.dif, 0);
      let notes: any[] = attendees.filter((el) => el.food === food.$key && el.note && el.note.length > 0 ).map((order) => order.note);

     return {
        food: food.$key,
        image: food.image,
        name: food.name,
        dif: dif || 0,
        total: attendees.filter((el) => el.food === food.$key).length,
        notes: (notes.length > 0) ? notes.join(' // ') : undefined
      };
    });
  }

  private readAlerts(): void {
    this.birthdayFocus.updates.forEach((alert) => {
      alert.read = true;
    });

    this.birthdaysService.saveBirthday(this.birthdayFocus);
  }

  private hasPendingNotes(order): boolean {
    return this.pendingAlerts.filter((alert) => alert.food === order.food && alert.note ).length > 0;
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/kitchen/kitchen.component.ts